import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'react-final-form-arrays';
import { Checkbox, Col, Row } from '@folio/stripes-components';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import className from 'classnames';
import BarcodePatternValues from './BarcodePatternValues';
import css from './styles.css';

function PatternDesign({ fields }) {
  //   const [patternValues, setPatternValues] = useState([
  //     'campusCode',
  //     'libraryCode',
  //     'locationCode',
  //     'yearCode',
  //     'monthCode',
  //     'dayCode',
  //     'serialNo',
  //   ]);
  //   const reorder = (list, startIndex, endIndex) => {
  //     const result = Array.from(list);
  //     const [removed] = result.splice(startIndex, 1);
  //     result.splice(endIndex, 0, removed);

  //     return result;
  //   };

  //   const onDragEnd = (result) => {
  //     if (!result.destination) {
  //       return;
  //     }

  //     const items = reorder(
  //       patternValues,
  //       result.source.index,
  //       result.destination.index,
  //     );

  //     setPatternValues(items);
  //   };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    fields.move(result.source.index, result.destination.index);
  };

  const renderValuesArray = () => {
    return (
      <>
        {fields.map((item, index) => {
          return (
            <Draggable
              key={item}
              draggableId={item}
              index={index}
              //   disableInteractiveElementBlocking={false}
              isDragDisabled={false}
            >
              {(draggableProvided, snapshot) => (
                <BarcodePatternValues
                  draggableProvided={draggableProvided}
                  item={item}
                  fieldIndex={index}
                  fieldLabel={fields.value[index]}
                  snapshot={snapshot}
                />
              )}
            </Draggable>
          );
        })}
      </>
    );
  };

  return (
    <div id="pattern-values-droppable">
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable
          droppableId="pattern-values-droppable"
        //   direction="horizontal"
        >
          {(droppableProvided, snapshot) => (
            <div
              ref={droppableProvided.innerRef}
            //   style={{
            //     background: snapshot.isDraggingOver ? 'lightblue' : 'lightgrey',
            //     display: 'flex',
            //     padding: 8,
            //     flexWrap: 'wrap',
            //     overflow: 'auto',
            //   }}
              {...droppableProvided.droppableProps}
            >
              {renderValuesArray()}
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}

PatternDesign.propTypes = {
  fields: PropTypes.object,
};

export default PatternDesign;
